import {
    ApolloClient,
    InMemoryCache,
    HttpLink,
    NormalizedCacheObject,
  } from '@apollo/client'
import { cmsBaseUrl } from "../config/GlobalConfig";


const httpLink = new HttpLink({
    uri: `${cmsBaseUrl}/modules/graphql`,
    headers: {
        'Content-Type': 'application/json'
    }
});

 const cmsClient = new ApolloClient<NormalizedCacheObject>({
    link: httpLink,
    cache: new InMemoryCache()
});

export default cmsClient;